module.exports = __webpack_public_path__ + "static/img/task.ddcdd30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/task.png
// module id = oP4J
// module chunks = 1